"use client";
import { jsxs as l, jsx as e } from "react/jsx-runtime";
const d = ({
  title: i,
  titleId: r,
  desc: n,
  descId: o,
  ...t
}) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": r,
    "aria-describedby": o,
    ...t,
    children: [
      n ? /* @__PURE__ */ e("desc", { id: o, children: n }) : null,
      i ? /* @__PURE__ */ e("title", { id: r, children: i }) : null,
      /* @__PURE__ */ e(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 1.5,
          d: "m17.4347 10.2904-3.7251-3.7251M3 21l3.1518-.3502c.385-.0428.5776-.0642.7575-.1224a1.86 1.86 0 0 0 .4517-.2171c.158-.1042.295-.2411.5689-.5151L20.2285 7.4966c1.0287-1.0287 1.0287-2.6965 0-3.7251s-2.6964-1.0287-3.7251 0L4.2048 16.07c-.274.274-.411.411-.515.5689a1.86 1.86 0 0 0-.2172.4517c-.0582.1799-.0796.3725-.1224.7575z"
        }
      )
    ]
  }
);
export {
  d as default
};
